<template>
  <ValidationObserver
    v-slot="{handleSubmit}"
    ref="formObserver"
  >
    <b-modal
      id="dimensionModal"
      v-model="dimensionModal.show"
      :title="`${form.entityId ? 'Edit' : 'Create'} Dimension`"
      @hidden="hideModal"
      @ok.prevent="handleSubmit(onSubmit)"
      @hide="beforeHide"
      @show="showModal"
    >
      <content-spinner
        :show="dimensionModal.loading"
        text="Please wait..."
      />
      <b-form
        v-if="!dimensionModal.loading"
        @submit="handleSubmit(onSubmit)"
        @reset="handleSubmit(onReset)"
        @keydown.enter.prevent="handleSubmit(onSubmit)"
      >
        <input-widget
          ref="focusedField"
          :model="form"
          :field="fields.entityDisplayName"
          :autofocus="true"
        />
        <input-widget
          :model="form"
          :field="fields.description"
        />
        <input-widget
          :model="form"
          :field="fields.tags"
        />
        <!--        <input-widget :model="form" :field="fields.deletionType"/>-->
        <input-widget
          :model="form"
          :field="fields.isOnPhysicalModel"
        />
        <input-widget
          :model="form"
          :field="fields.isOnLogicalModel"
        />
      </b-form>

      <template #modal-footer="{ok, cancel, hide}">
        <modal-footer
          v-if="!form.entityId"
          v-model="addAnother"
          :loading="dimensionModal.loading"
          :cancel="cancel"
          :ok="ok"
        />
      </template>
    </b-modal>
  </ValidationObserver>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import ContentSpinner from '../../core/components/ContentSpinner';
import {ValidationProvider, extend, ValidationObserver} from 'vee-validate';
import InputWidget from '../../core/components/complex-table/components/InputWidget';
import ModalFooter from './components/ModalFooter';
import {v4 as uuidv4} from 'uuid';
import {updateDimension} from '../../store/modules/sun-model/actions';

const {mapState, mapGetters, mapActions} = createNamespacedHelpers('sunModel');
export default {
  name: 'DimensionModal',
  components: {ModalFooter, InputWidget, ContentSpinner, ValidationProvider, ValidationObserver},
  data() {
    return {
      form: {
        entityDisplayName: '',
        description: '',
        tags: [],
        attributes: [],
        // changeType: '',
        // deletionType: '',
        isOnPhysicalModel: true,
        isOnLogicalModel: true,
      },
      addAnother: false,
      fields: {
        entityDisplayName: {
          type: 'text',
          required: true,
          label: 'Name',
          name: 'entityDisplayName',
        },
        description: {
          type: 'textarea',
          required: false,
          label: 'Description',
          name: 'description',
        },
        tags: {
          type: 'multi-select',
          required: false,
          name: 'tags',
          config: {
            optionValue: 'value',
            optionLabel: 'name',
            placeholder: 'Dimension Tags',
            multiple: true,
            taggable: false,
          },
          data: {
            options: [],
          },
        },
        /*deletionType: {
          type: 'radio-group',
          required: false,
          label: 'Deletion Type',
          name: 'deletionType',
          data: {
            options: [
              {text: 'Implicit', value: 'implicit'},
              {text: 'Explicit', value: 'explicit'},
            ]
          }
        },*/
        isOnPhysicalModel: {
          type: 'checkbox',
          required: false,
          label: 'Include On Physical Model',
          name: 'isOnPhysicalModel',
        },
        isOnLogicalModel: {
          type: 'checkbox',
          required: false,
          label: 'Include On Logical Model',
          name: 'isOnLogicalModel',
        },
      },
    };
  },
  watch: {
    tags: {
      immediate: true,
      deep: true,
      handler() {
        this.fields.tags.data.options = this.tags.data.map(t => ({name: t.tagName, value: t.tagId}));
      },
    },
  },
  computed: {
    ...mapState(['dimensionModal', 'tags']),
    ...mapGetters(['tagsAsMap']),
  },
  methods: {
    ...mapActions(['hideDimensionModal', 'createDimension', 'updateDimension']),
    beforeHide(e) {
      if (this.dimensionModal.loading) {
        e.preventDefault();
        return false;
      }
    },
    async onSubmit(e) {
      // e.preventDefault();
      let params = {...this.form};
      let action = 'create';
      if (params.entityId) {
        params = {
          entityId: params.entityId,
          entityType: params.entityType,
          entityDisplayName: params.entityDisplayName,
          description: params.description ? params.description : '',
          tags: JSON.stringify(params.tags.map(t => t.value)),
          isOnPhysicalModel: params.isOnPhysicalModel,
          isOnLogicalModel: params.isOnLogicalModel,
        };
        action = 'update';
      } else {
        params.entityId = uuidv4();
        params.entityType = 'dim';
        params.tags = JSON.stringify(params.tags.map(t => t.value));
        action = 'create';
      }
      // delete params.tags

      let res;
      if (action === 'create') {
        res = await this.createDimension(params);
      } else {
        res = await this.updateDimension(params);
      }

      if (res.success) {
        if (!this.addAnother) {
          this.hideModal();
        }
        this.$toasted.success('Dimension record saved successfully', {
          duration: TOASTER_DURATION,
        });
        this.resetModal();
        this.$refs.focusedField.$refs.currentInput.focus();
      } else {
        this.$toasted.error(res.body.ErrorMessage, {
          duration: TOASTER_DURATION,
        });
      }
    },
    resetModal() {
      this.form = {
        entityDisplayName: '',
        description: '',
        tags: [],
        // changeType: '',
        // deletionType: '',
        isOnPhysicalModel: true,
        isOnLogicalModel: true,
      };
      this.$refs.formObserver.reset();
    },
    hideModal() {
      this.addAnother = false;
      this.hideDimensionModal();
    },
    showModal() {
      this.form = {
        ...this.dimensionModal.data,
        tags: this.dimensionModal.data.tags.map(tagId => {
          const tag = this.tagsAsMap.get(tagId) || {};
          return {name: tag.tagName, value: tagId};
        }),
      };
    },
    onReset() {

    },
  },
};
</script>

<style lang="scss">
#dimensionModal {
  /deep/ .lobi-spinner {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    z-index: 1;
  }
}
</style>
